import React, { useEffect, useState } from 'react';
import Bowser from 'bowser';
import { GenericErrorPage } from '@vitvio/shared-components';
import { Text } from '@vitvio/design-system';

export function BrowserDetection({ children }: { children: React.ReactNode }) {
  const [isSupported, setIsSupported] = useState(true);

  useEffect(() => {
    const detectBrowser = () => {
      const browser = Bowser.getParser(window.navigator.userAgent);
      const browserName = browser.getBrowserName();

      const isSupported = browserName === 'Chrome' || browserName === 'Microsoft Edge';

      if (!isSupported) {
        setIsSupported(false);
      }
    };

    detectBrowser();
  }, []);

  return isSupported ? (
    children
  ) : (
    <GenericErrorPage errorHeadingText="Browser not supported">
      <Text>Please use Google Chrome or Microsoft Edge to access the platform.</Text>
      <Text>Or reach out to your IT department.</Text>
    </GenericErrorPage>
  );
}
